module.exports = __webpack_public_path__ + "img/stickers_0006_phone.b064fd8a.png";